function InfoGroup ({ children }) {
    return (
        <div className='info-group'> 
            {children} 
        </div>
    )
}

export default InfoGroup;